<template lang="pug">
  
  v-menu(
      transition="slide-x-transition"
      bottom
      right
    )  
      template( v-slot:activator="{ on }" )
        v-btn(
          icon
          v-on="on"
        ) 
          v-icon(small :color='obtener_color_de_estado(estado_del_documento)') {{ obtener_icono_de_estado(estado_del_documento) }} 

      v-list
        v-list-item(
          v-for="(item, i) in menu_a_imprimir"
          :key="i"
          @click="item.callback"
        )
          v-list-item-title {{ item.text }}
</template>
<script>
import {mapActions} from 'vuex'
export default {
  data: vm => ({
    menu_original: [
      { text: 'Enviar a almacén', callback: () => vm.procesar({key: vm.id, tipo_de_operacion: 'entrada' }), estado_de_visibilidad: ['esperando'] },
      { text: 'Procesando...', callback: () => null, estado_de_visibilidad: ['procesando'] },      
      { text: 'Editar', callback: () => vm.get(vm.id), estado_de_visibilidad: ['esperando']},
      { text: 'Ver', callback: () => vm.get(vm.id), estado_de_visibilidad: ['procesado', 'emitido'] },
      { text: 'Revertir de almacén', callback: () => vm.procesar({key: vm.id, tipo_de_operacion: 'salida', es_reversion: true}), estado_de_visibilidad: ['procesado'] },
    ],
    menu_a_imprimir: []
  }),

  props:{
    estado_del_documento: String,
    id: String,
  },
  watch: {
    'estado_del_documento'(){
      this.filtrar_menu()
    }
  },
  created(){
    this.filtrar_menu()
  },
  methods: {
    filtrar_menu(){
      this.menu_a_imprimir = this.menu_original.filter(item => item.estado_de_visibilidad.indexOf(this.estado_del_documento) > -1)
    },
    ...mapActions({
      procesar: 'Kardex/comprobar_proceso_disponible',
      des_procesar: 'Inputs/des_procesar',
      emitir: 'Inputs/emitir',
      des_emitir: 'Inputs/des_emitir',
      get: 'Inputs/get',
    }),
  }
}
</script>
